import { useAppDispatch, useAppSelector } from "@app/hooks";
import { useApi } from "@services/useApi";
import { appendAssessmentNote } from "@store/assessmentResultSlice";
import { Note } from "@store/generalTypes";
import { NotesContainer } from "./notesContainer";

export const AssessmentNotes = ({ notes }: AssessmentNotesProps): JSX.Element => {
    const { reviewAssessment } = useApi();
    const { assessmentResult, location } = useAppSelector((x) => {
        return {
            assessmentResult: x.assessmentResult,
            location: x.orgLocations.currentLocation
        };
    });
    const dispatch = useAppDispatch();

    const handleOnCreateNote = async (note: Note): Promise<void> => {
        const noteId = await reviewAssessment(location!.id, assessmentResult.id, note.text);

        note.id = noteId.id;

        dispatch(appendAssessmentNote(note));

        return await Promise.resolve();
    };

    return <NotesContainer notes={notes} showNoteDetail allowAddNote onCreateNote={handleOnCreateNote} />;
};

interface AssessmentNotesProps {
    notes?: Note[];
}
